const API_BASE = 'https://bot.nt55.ru';

// --- Auth ---
export async function login(username: string, password: string) {
  const formData = new URLSearchParams();
  formData.append('username', username);
  formData.append('password', password);

  const res = await fetch(`${API_BASE}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: formData.toString(),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.detail || 'Ошибка');
  }
  return res.json();
}

export function getToken() {
  return localStorage.getItem('token');
}

export function apiHeaders(): Record<string, string> {
  const headers: Record<string, string> = {};
  const token = getToken();
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
}

// --- Scenarios ---
export interface Scenario {
  id: number;
  name: string;
  trigger?: string;
  config: any;
  is_active: boolean;
}

export async function fetchScenarios(): Promise<Scenario[]> {
  const res = await fetch(`${API_BASE}/api/scenarios/`, {
    headers: apiHeaders(),
  });
  if (!res.ok) throw new Error('Ошибка загрузки сценариев');
  return res.json();
}

export async function createScenario(data: { name: string; trigger?: string; config: any }): Promise<Scenario> {
  const res = await fetch(`${API_BASE}/api/scenarios/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...apiHeaders() },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Ошибка создания сценария');
  return res.json();
}

export async function updateScenario(id: number, data: { name?: string; trigger?: string; config?: any; is_active?: boolean }): Promise<Scenario> {
  const res = await fetch(`${API_BASE}/api/scenarios/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...apiHeaders() },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Ошибка обновления сценария');
  return res.json();
}

export async function deleteScenario(id: number): Promise<void> {
  const res = await fetch(`${API_BASE}/api/scenarios/${id}`, {
    method: 'DELETE',
    headers: apiHeaders(),
  });
  if (!res.ok) throw new Error('Ошибка удаления сценария');
}
